import React from "react";
import {
    Container
} from "reactstrap";
import MetaTags from "react-meta-tags";
import Breadcrumb from "../../components/Common/Breadcrumb";
import Blogs from "components/Happy60/blogs/blog";

const BlogPage = () => {
    return (
        <React.Fragment>
            <div className="page-content">
                <MetaTags>
                    <title>Blog | Happy60Plus</title>
                </MetaTags>
                <Container fluid>
                    {/* Render Breadcrumb */}
                    <Breadcrumb title="Home" breadcrumbItem="Bookings" />

                    <Blogs></Blogs>

                </Container>
            </div >
        </React.Fragment >
    );
}

export default BlogPage;